module.exports = __webpack_public_path__ + "img/7b18604.jpg";